import React from 'react'
import { connect } from 'react-redux'
import imgData from './logodata'
import jsPDF from 'jspdf';
import 'jspdf-autotable';

class PDFfile extends React.Component {

	localDateString(einDatum) {
		const d = new Date(einDatum);
		return `${d.getDate()}.${d.getMonth()+1}.${d.getFullYear()}`
	}

	fuehrerscheinValue(f) {
		var res = '';
		if (f === undefined || f.length === 0) {
			return [{fn_id: '-', fn_date: ''}];
		}

		res = f.map((ff,i) => {
			if (!ff.licenseValid) {
				return {fn_id: ff.licenseId, fn_date: 'Bitte checken!'};
			} else {
				return {fn_id: ff.licenseId, fn_date: this.localDateString(ff.licenseValidDate)};
			}
		})
		return res;
	}

	demoFromHTML() {

		const columns = [
			{
				title: "Nummer",
				dataKey: "id"
			}, {
				title: "Email",
				dataKey: "email"
			}, {
				title: "Ladegut-Sicherung-Tutorial",
				dataKey: "email_sent"
			}, {
				title: "bestanden",
				dataKey: "video_seen"
			}, {
				title: "Führerschein",
				dataKey: "fn_id"
			}, {
				title: "Führerscheinkontrolle am",
				dataKey: "fuehrerschein"
			}
		];

		const rows = [];
		var i = 0;

		for (var f of this.props.fahrer) {

					const fValue = this.fuehrerscheinValue(f.fuehrerschein);
					i += 1;

					var fn = fValue.shift();
					console.log("fn:", fn, f);

					var rObj = {};
					rObj.id = i;
					rObj.email = f.email;
					rObj.email_sent = f.emailSentDate ? this.localDateString(f.emailSentDate) : "-";
					rObj.video_seen = f.videoSeenDate ? this.localDateString(f.videoSeenDate) : "-";
					rObj.fuehrerschein = fn.fn_date;
					rObj.fn_id = fn.fn_id;
					rows.push(rObj);

					while (fValue.length > 0) {
						fn = fValue.shift();
						rObj = {};
						rObj.id = i;
						rObj.email = f.email;
						rObj.email_sent = '';
						rObj.video_seen = '';
						rObj.fuehrerschein = fn.fn_date;
						rObj.fn_id = fn.fn_id;
						rows.push(rObj);
					}
				};

		//console.log(rows);

		var doc = new jsPDF('l', 'pt');
		doc.page = 1;

		//doc.addFont('Herculanum', 'Herculanum', 'normal');

		console.log(doc.getFontList());

		doc.addImage(imgData, 'PNG', 685, 25, 118.5, 46);

		doc.text(270,820,'- ' + doc.page + ' -');

		const d = new Date();

		doc.autoTable(columns, rows, {
			theme: 'striped',
			styles: {
				fillColor: 220,
				font: 'Helvetica'
			},
			columnStyles: {
			},
			headerStyles: {
				fillColor: 160,
				font: 'Helvetica'
			},
			margin: {
				top: 120
			},
			addPageContent: function(data) {
				doc.setFontType("bold");
				doc.text("Der schlaue Blaue", 40, 50);
				doc.setFontType("normal");
				doc.text("Ladegut-Sicherung und Führerscheinkontrolle im geschäftlich genutzten Fahrzeug", 40, 75)
				doc.setFontType("italic");
				doc.text(`Teilnehmer-Übersicht ${d.getDate()}.${d.getMonth()+1}.${d.getFullYear()}`, 40, 105);
				doc.setFontType("normal");
			}
		});

		const docTitle = `Fahrer_${d.getDate()}-${d.getMonth()+1}-${d.getFullYear()}_${d.getHours()}${d.getMinutes()}${d.getSeconds()}.pdf`

		doc.save(docTitle);
	}

	render() {
		return (<button className="float-right btn btn-default" onClick={(e) => {
			 e.preventDefault();
			 this.demoFromHTML();
		 	}
		 }>
			PDF laden
		</button>);
	}
}

function mapStateToProps({fahrer}) {
	return { fahrer }
}

//export default PDFfile;

export default connect(mapStateToProps)(PDFfile);



// WEBPACK FOOTER //
// ./src/components/fahrer/FahrerPdf2.js